import { createMetaManager } from 'vue-meta'

import app from '@/app'

export type { HTMLMeta } from './types'

const metaManager = createMetaManager(false, {})

app.use(metaManager)
